import { gql } from "@apollo/client";
import { useCallback } from "react";
import { useQuery } from "@apollo/client/react";
import { CURRENCY_FRAGMENT } from "../../fragments/menu";
import { ALLERGENS_FRAGMENT, WEIGHT_FRAGMENT, FOOD_ENERGY_FRAGMENT } from "../../fragments/menuItem";

import type { UseOptions } from "../hookTypes"
import type { FetchQrCode } from "../../types/qrCodeTypes";

const FETCH_QR_CODE = gql`
  query FetchQrCode($publicId: ID!) {
    qrCode(publicId: $publicId) {
      id
      name
      description
      restaurant {
        id
        name
        img {
          small
        }
        phone
        website
        wifi
      }
      languages {
        position
        language
      }
      ...CurrencyFragment
      mainLanguage
      menuSections {
        id
        name
      }
      menuItems {
        id
        menuItemLangs {
          id
          name
          description
          language
        }
        ...AllergensFragment
        ...WeightFragment
        ...FoodEnergyFragment
        vegan
        chili
        hot
        price
        img {
          small
          medium
        }
        menuId
        mainItemLang {
          id
          name
          description
          language
        }
        menuSectionIds
      }
    }
  }
  ${CURRENCY_FRAGMENT}
  ${ALLERGENS_FRAGMENT}
  ${WEIGHT_FRAGMENT}
  ${FOOD_ENERGY_FRAGMENT}
`;

const useMenuQrCode = (publicId: string | undefined, options?: UseOptions) => {
  const { fetchPolicy = "cache-and-network", refetchOnMount = false } = options ?? {};

  const { data, loading, error, refetch } = useQuery<FetchQrCode>(FETCH_QR_CODE, {
    variables: { publicId: publicId },
    fetchPolicy,
    notifyOnNetworkStatusChange: true,
  });

  if (refetchOnMount && !loading) {
    refetch();
  }

  const menu = data?.qrCode

  const refetchQrCode = useCallback(async () => {
    try {
      await refetch();
    } catch {
      // log if need
    }
  }, [refetch]);

  return {
    menu,
    loading,
    error: error as Error | null | undefined,
    refetchQrCode,
  };
}

export default useMenuQrCode
